import styled from "styled-components";

const ProjectCardWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: ${(prop) => (prop.id % 2 === 0 ? "row-reverse" : "row")};
  gap: 20px;

  & .project_card__image-section {
    width: 40%;
    padding: 10px;
  }

  & .project_card__info-section {
    width: 60%;
    padding: 10px;
  }

  & .project_card__info-section h2,
  & .project_card__links,
  & .project_card__techs {
    margin-left: ${(prop) => prop.id % 2 !== 0 && "auto"};
    width: fit-content;
    padding-right: 10px;
  }

  & .project_card__info-para {
    background-color: #112240;
    padding: 10px;
    border-radius: 6px;
  }

  /* =============================
     LINKS
  ============================== */
  & a {
    text-decoration: none;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* Disabled link */
  & a[data-disabled="true"] {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.4;
  }

  /* Icon */
  & a svg {
    height: 30px;
    width: 30px;
    color: white;
    transition: transform 0.25s ease, opacity 0.25s ease;
  }

  /* Hover using scale (smooth, no layout shift) */
  & a:not([data-disabled="true"]):hover svg {
    transform: scale(1.3);
  }

  & a:not([data-disabled="true"]):active svg {
    transform: scale(1.15);
  }

  /* =============================
     IMAGE
  ============================== */
  & img {
    width: 100%;
    object-fit: cover;
    box-shadow: 6px 8px 5px 0px #64ffda;
    border-radius: 10px;
    background-color: #64ffda;
    mix-blend-mode: luminosity;
    transition: mix-blend-mode 0.3s ease;
  }

  & img:hover {
    mix-blend-mode: normal;
  }

  /* =============================
     MOBILE
  ============================== */
  @media (max-width: 600px) {
    flex-direction: column;

    & .project_card__image-section,
    & .project_card__info-section {
      width: 100%;
    }
  }

  /* Show More button wrapper */
  & .project_card__more-btn {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }

  /* Button style */
  & .project_card__more-btn button {
    background: transparent;
    border: 2px solid #64ffda;
    color: #64ffda;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.25s ease;
  }

  & .project_card__more-btn button:hover {
    background-color: #64ffda;
    color: #0a192f;
  }
`;

export default ProjectCardWrapper;
